<script lang="ts">
export default {
  name: "FilterFormDropdown",
};
</script>

<script setup lang="ts">
import { computed } from "vue";
import { BaseButtonKindEnum } from "@/components/Base/Button";

interface Option {
  value: string;
  label: string;
}

interface Props {
  id: string;
  label: string;
  options: Option[];
  buttonClass?: string;
  kind?: BaseButtonKindEnum;
  selectedValues: string;
}

const props = withDefaults(defineProps<Props>(), {
  buttonClass: undefined,
  kind: BaseButtonKindEnum.NAKED,
  selectedValues: "",
});

const emit = defineEmits(["update:selectedValues", "change"]);

const selectedValue = computed({
  get: (): string => props.selectedValues || "",
  set: (value: string) => {
    const newValues = value ? value : "";
    emit("update:selectedValues", newValues);
    emit("change", newValues);
  },
});
</script>

<template>
  <BaseFormDropdown
    :id="id"
    v-model="selectedValue"
    auto-close="outside"
    :label="label"
    variant="primary"
    :options="options"
    :button-class="buttonClass"
    :kind="kind"
  />
</template>
